import RLogo from "./Ricon";
export default RLogo;